import AbstractEventHookManager from "./AbstractEventHookManager";

export default class EventManager extends AbstractEventHookManager{

    constructor(protected componentInstance:VideoJSComponent){
        super();
    }

    /**
     * Get trigger function to trigger a event
     */
    getTrigger<T>(eventType:T) {
        return (args:any[]) => {
            this.componentInstance.trigger.apply(this.componentInstance, [this.typeToString<T>(eventType)].concat(args));
        }
    }

    /**
     * Trigger a event
     */
    trigger<T>(eventType:T,...args:any[]){
        this.getTrigger(this.typeToString<T>(eventType))(args);
    }

    /**
     * Add event listener
     */
    addListener<T>(eventType:T, listener:Function){
        this.componentInstance.on(this.typeToString<T>(eventType), listener.bind(this));
    }

}



// WEBPACK FOOTER //
// ./src/app/communication/EventManager.ts